import { AppDownloadHeader } from './AppDownloadHeader';

export default AppDownloadHeader;
